export const TEMPLATES = {
  simple: {
    name: "John Doe",
    age: 30,
    email: "john@example.com",
    active: true,
  },
  nested: {
    user: {
      id: 1,
      profile: {
        name: "Jane",
        details: {
          hobbies: ["reading", "coding"],
          location: "NY",
        },
      },
    },
  },
  array: [
    { id: 1, item: "Apple", price: 1.2 },
    { id: 2, item: "Banana", price: 0.8 },
    { id: 3, item: "Cherry", price: 2.5 },
  ],
  complex: {
    company: {
      id: "comp-12345",
      name: "Tech Innovations Inc.",
      founded: "2015-03-15",
      headquarters: {
        address: {
          street: "123 Innovation Drive",
          city: "San Francisco",
          state: "CA",
          zip: "94105",
          country: "USA",
          coordinates: {
            latitude: 37.7749,
            longitude: -122.4194,
          },
        },
      },
      departments: [
        {
          id: "dept-001",
          name: "Engineering",
          manager: {
            employeeId: "emp-1001",
            name: "Alice Johnson",
            email: "alice@techinnovations.com",
            role: "VP of Engineering",
            team: {
              members: [
                {
                  id: "emp-1002",
                  name: "Bob Smith",
                  role: "Senior Software Engineer",
                  skills: ["TypeScript", "React", "Node.js"],
                  projects: [
                    {
                      id: "proj-001",
                      name: "Platform Redesign",
                      status: "in-progress",
                      priority: "high",
                    },
                  ],
                },
                {
                  id: "emp-1003",
                  name: "Carol White",
                  role: "DevOps Engineer",
                  skills: ["Docker", "Kubernetes", "AWS"],
                  projects: [
                    {
                      id: "proj-002",
                      name: "Infrastructure Migration",
                      status: "completed",
                      priority: "critical",
                    },
                  ],
                },
              ],
            },
          },
        },
        {
          id: "dept-002",
          name: "Product",
          manager: {
            employeeId: "emp-2001",
            name: "David Brown",
            email: "david@techinnovations.com",
            role: "VP of Product",
            team: {
              members: [
                {
                  id: "emp-2002",
                  name: "Eva Green",
                  role: "Product Manager",
                  skills: ["Strategy", "Analytics", "UX"],
                  projects: [
                    {
                      id: "proj-003",
                      name: "Mobile App Launch",
                      status: "planning",
                      priority: "medium",
                    },
                  ],
                },
              ],
            },
          },
        },
      ],
      financials: {
        revenue: {
          "2023": {
            Q1: 2500000,
            Q2: 2800000,
            Q3: 3100000,
            Q4: 3500000,
            total: 11900000,
          },
          "2024": {
            Q1: 3800000,
            Q2: 4200000,
            Q3: 4500000,
            Q4: 5000000,
            total: 17500000,
          },
        },
        expenses: {
          salaries: 8500000,
          infrastructure: 1200000,
          marketing: 1800000,
          operations: 900000,
        },
      },
      settings: {
        features: {
          analytics: true,
          reporting: true,
          integrations: {
            slack: { enabled: true, webhook: "https://hooks.slack.com/xxx" },
            jira: { enabled: false, apiKey: null },
            github: { enabled: true, token: "ghp_xxxxxxxxxxxx" },
          },
        },
        preferences: {
          theme: "dark",
          notifications: {
            email: true,
            push: false,
            sms: false,
          },
          language: "en-US",
        },
      },
    },
  },
  ecommerce: {
    order: {
      id: "ORD-2024-001234",
      customer: {
        id: "CUST-5678",
        name: "Michael Chen",
        email: "michael.chen@email.com",
        phone: "+1-555-0123",
        address: {
          billing: {
            street: "456 Commerce Street",
            apartment: "Suite 200",
            city: "New York",
            state: "NY",
            zip: "10001",
            country: "USA",
          },
          shipping: {
            street: "456 Commerce Street",
            apartment: "Suite 200",
            city: "New York",
            state: "NY",
            zip: "10001",
            country: "USA",
            sameAsBilling: true,
          },
        },
        preferences: {
          currency: "USD",
          language: "en",
          newsletter: true,
        },
      },
      items: [
        {
          sku: "PROD-001",
          name: "Wireless Headphones",
          category: {
            primary: "Electronics",
            secondary: "Audio",
            tags: ["wireless", "bluetooth", "premium"],
          },
          quantity: 2,
          price: {
            unit: 199.99,
            currency: "USD",
            discount: {
              type: "percentage",
              value: 10,
              applied: true,
            },
          },
          total: 359.98,
          specifications: {
            color: "Black",
            weight: "250g",
            battery: "30 hours",
            connectivity: ["Bluetooth 5.0", "3.5mm Jack", "USB-C"],
          },
        },
        {
          sku: "PROD-002",
          name: "Laptop Stand",
          category: {
            primary: "Accessories",
            secondary: "Desk Accessories",
            tags: ["ergonomic", "adjustable", "aluminum"],
          },
          quantity: 1,
          price: {
            unit: 89.99,
            currency: "USD",
            discount: null,
          },
          total: 89.99,
          specifications: {
            material: "Aluminum",
            weight: "1.2kg",
            adjustable: true,
            maxWeight: "15kg",
          },
        },
      ],
      pricing: {
        subtotal: 449.97,
        tax: {
          rate: 0.08,
          amount: 35.998,
        },
        shipping: {
          method: "express",
          cost: 15.99,
          estimatedDays: 2,
        },
        discount: {
          code: "SAVE10",
          amount: 20.0,
        },
        total: 480.958,
      },
      payment: {
        method: "credit_card",
        status: "completed",
        transactionId: "TXN-987654321",
        processedAt: "2024-01-15T10:30:00Z",
      },
      status: {
        current: "shipped",
        history: [
          {
            status: "pending",
            timestamp: "2024-01-15T09:00:00Z",
            note: "Order received",
          },
          {
            status: "processing",
            timestamp: "2024-01-15T09:15:00Z",
            note: "Payment confirmed",
          },
          {
            status: "shipped",
            timestamp: "2024-01-15T14:30:00Z",
            note: "Package dispatched via Express Shipping",
            tracking: {
              carrier: "FedEx",
              number: "1234567890",
              url: "https://fedex.com/track/1234567890",
            },
          },
        ],
      },
    },
  },
  apiResponse: {
    success: true,
    data: {
      users: [
        {
          id: 1,
          username: "johndoe",
          profile: {
            firstName: "John",
            lastName: "Doe",
            avatar: "https://api.example.com/avatars/johndoe.jpg",
            bio: "Software engineer passionate about web development",
            social: {
              twitter: "@johndoe",
              github: "johndoe",
              linkedin: "johndoe",
            },
          },
          metadata: {
            createdAt: "2020-01-15T08:30:00Z",
            lastLogin: "2024-01-20T14:22:00Z",
            loginCount: 1247,
            preferences: {
              theme: "dark",
              notifications: {
                email: true,
                push: true,
                sms: false,
              },
            },
          },
          permissions: {
            roles: ["user", "premium"],
            features: {
              canEdit: true,
              canDelete: false,
              canPublish: true,
              canModerate: false,
            },
          },
        },
        {
          id: 2,
          username: "janedoe",
          profile: {
            firstName: "Jane",
            lastName: "Doe",
            avatar: "https://api.example.com/avatars/janedoe.jpg",
            bio: "Designer and creative director",
            social: {
              twitter: "@janedoe",
              github: null,
              linkedin: "janedoe",
            },
          },
          metadata: {
            createdAt: "2019-06-20T10:15:00Z",
            lastLogin: "2024-01-20T16:45:00Z",
            loginCount: 2156,
            preferences: {
              theme: "light",
              notifications: {
                email: true,
                push: false,
                sms: false,
              },
            },
          },
          permissions: {
            roles: ["user", "admin"],
            features: {
              canEdit: true,
              canDelete: true,
              canPublish: true,
              canModerate: true,
            },
          },
        },
      ],
      pagination: {
        page: 1,
        perPage: 20,
        total: 150,
        totalPages: 8,
        hasNext: true,
        hasPrev: false,
      },
      filters: {
        status: ["active", "verified"],
        roles: ["user"],
        dateRange: {
          from: "2020-01-01",
          to: "2024-12-31",
        },
      },
    },
    meta: {
      requestId: "req-abc123def456",
      timestamp: "2024-01-20T18:00:00Z",
      version: "v2.1.0",
      rateLimit: {
        remaining: 499,
        resetAt: "2024-01-20T19:00:00Z",
      },
    },
  },
  configuration: {
    application: {
      name: "Enterprise Dashboard",
      version: "2.5.0",
      environment: "production",
      debug: false,
    },
    server: {
      host: "0.0.0.0",
      port: 3000,
      protocol: "https",
      cors: {
        enabled: true,
        origins: [
          "https://app.example.com",
          "https://admin.example.com",
          "https://api.example.com",
        ],
        methods: ["GET", "POST", "PUT", "DELETE", "PATCH"],
        credentials: true,
      },
    },
    database: {
      type: "postgresql",
      host: "db.example.com",
      port: 5432,
      name: "enterprise_db",
      ssl: {
        enabled: true,
        rejectUnauthorized: true,
        ca: "/path/to/ca-cert.pem",
      },
      pool: {
        min: 5,
        max: 20,
        idleTimeout: 30000,
      },
      replication: {
        enabled: true,
        read: [
          {
            host: "db-read-1.example.com",
            port: 5432,
          },
          {
            host: "db-read-2.example.com",
            port: 5432,
          },
        ],
      },
    },
    cache: {
      provider: "redis",
      host: "cache.example.com",
      port: 6379,
      ttl: 3600,
      clusters: [
        {
          host: "cache-1.example.com",
          port: 6379,
        },
        {
          host: "cache-2.example.com",
          port: 6379,
        },
      ],
    },
    features: {
      authentication: {
        enabled: true,
        providers: {
          local: {
            enabled: true,
            minPasswordLength: 8,
            requireUppercase: true,
            requireNumbers: true,
            requireSpecialChars: true,
          },
          oauth: {
            enabled: true,
            providers: [
              {
                name: "google",
                clientId: "google-client-id",
                clientSecret: "google-client-secret",
                scopes: ["email", "profile"],
              },
              {
                name: "github",
                clientId: "github-client-id",
                clientSecret: "github-client-secret",
                scopes: ["user:email", "read:user"],
              },
            ],
          },
        },
        session: {
          duration: 86400,
          refreshToken: true,
        },
      },
      analytics: {
        enabled: true,
        provider: "mixpanel",
        apiKey: "mixpanel-api-key",
        events: {
          userSignup: true,
          userLogin: true,
          pageView: true,
          customEvents: true,
        },
      },
      monitoring: {
        enabled: true,
        services: {
          sentry: {
            enabled: true,
            dsn: "https://xxx@sentry.io/xxx",
            environment: "production",
          },
          datadog: {
            enabled: true,
            apiKey: "datadog-api-key",
            appKey: "datadog-app-key",
          },
        },
      },
    },
  },
} as const

export type TemplateKey = keyof typeof TEMPLATES
